// eslint-disable-next-line
import i18n from "../../components/i18n";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { faVolumeUp, faLock, faImage, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";

function ToolsIndex() {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  var toolsItems = t("Tools", { returnObjects: true });

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  // Mapeamento de ícones para cada ferramenta, incluindo combinações
  const iconMap = {
    ConvertImages: (
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon icon={faImage} color="rgb(7, 249, 250)" />
      </span>
    ),
    QRCodeGenerator: (
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon icon={faQrcode} color="rgb(7, 249, 250)" />
      </span>
    ),
    PasswordGenerator: (
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon icon={faLock} color="rgb(7, 249, 250)" />
      </span>
    ),
    ImageResizer: (
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon icon={faImage} color="rgb(7, 249, 250)" />
      </span>
    ),
    TextToSpeech: (
      <span className="fa-layers fa-fw">
        <FontAwesomeIcon icon={faVolumeUp} color="rgb(7, 249, 250)" />
      </span>
    ),
  };

  // Gera a lista de ferramentas dinamicamente a partir do objeto de tradução
  const order = ["ConvertImages", "PasswordGenerator"];
  const toolsList = [
    ...order
      .filter((key) => toolsItems[key])
      .map((key) => {
        const tool = toolsItems[key];
        return {
          path:
            key === "ConvertImages"
              ? "/convert-images"
              : key === "PasswordGenerator"
              ? "/password-generator"
              : "/#",
          label: tool.Title,
          icon: iconMap[key] || faImage,
          desc: tool.Description,
          button: tool.ButtonText,
          available: key === "ConvertImages" || key === "PasswordGenerator",
        };
      }),
    ...Object.keys(toolsItems)
      .filter(
        (key) =>
          key !== "Title" &&
          key !== "Subtitle" &&
          key !== "Description" &&
          !order.includes(key)
      )
      .map((key) => {
        const tool = toolsItems[key];
        return {
          path:
            key === "QRCodeGenerator"
              ? "/qrcode-generator"
              : key === "ImageResizer"
              ? "/image-resizer"
              : key === "TextToSpeech"
              ? "/text-to-speech"
              : "/#",
          label: tool.Title,
          icon: iconMap[key] || faImage,
          desc: tool.Description,
          button: tool.ButtonText,
          available: false,
        };
      }),
  ];

  return (
      <div className="container-fluid tools py-5 mt-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 d-flex flex-column justify-content-center align-items-center first-section">
              <div className="col-12 d-flex justify-content-center title-container">
                <div className="title-row d-flex align-items-center justify-content-center">
                  <div className="title">{toolsItems.Title}</div>
                  <div className="animation-container-title"></div>
                </div>
              </div>
              <div className="col-12 text-center text-white-70 mt-2 mb-4 fs-5">
                {toolsItems.Subtitle}
              </div>
            </div>
            <div className="col-12 d-flex flex-wrap justify-content-center align-items-center gap-4 mt-3 second-section">
              {toolsList.map((tool, idx) => (
                <div
                  key={tool.path}
                  className="text-decoration-none"
                  style={{
                    minWidth: 260,
                    maxWidth: 340,
                    cursor: tool.available ? "pointer" : "not-allowed",
                    opacity: tool.available ? 1 : 0.6,
                  }}
                  onClick={() => tool.available && navigate(tool.path)}
                  tabIndex={tool.available ? 0 : -1}
                  aria-disabled={!tool.available}
                >
                  <div
                    className="card bg-dark text-white shadow-lg border-0 h-100 d-flex flex-column align-items-center p-4 tool-card"
                    style={{ borderRadius: 18 }}
                  >
                    <div
                      className="mb-3 box-icon"
                      style={{ fontSize: 48, color: "var(--third-color)" }}
                    >
                      {tool.icon}
                    </div>
                    <div className="fs-4 fw-bold mb-2 text-center">
                      {tool.label}
                    </div>
                    <div className="small text-white-70 text-center mb-3">
                      {tool.desc}
                    </div>
                    <button
                      className="btn btn-info w-100"
                      disabled={!tool.available}
                      style={{
                        pointerEvents: tool.available ? "auto" : "none",
                      }}
                    >
                      {tool.available ? tool.button : t("ComingSoon")}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
  );
}

export default ToolsIndex;
